import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-transaction-summary',
    templateUrl: './transaction-summary.component.html',
    styleUrls: ['./transaction-summary.component.scss'],
    standalone: false
})
export class TransactionSummaryComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
